<template>
  <main class="main profile-page sell-offers-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div :class="['title', 'big']">
            {{ title }}
          </div>
          <div :class="['desc', { red: isFailure, green: !isFailure }]">
            {{ description }}
          </div>

          <div class="actions">
            <RouterLink :to="{ name: 'Profile' }">
              <button class="button">
                <span>{{ isFailure ? "Try again" : "My profile" }}</span>
              </button>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "PayoutResultPage",
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => ["success", "failure"].includes(value),
    },
    message: {
      type: String,
      default: "",
    },
  },
  computed: {
    isFailure() {
      return this.status === "failure";
    },
    title() {
      return this.isFailure
        ? "Payout Request Failed."
        : "Your Payout Request Has Been Submitted.";
    },
    description() {
      if (this.message) {
        return this.message;
      }
      return this.isFailure
        ? "Sorry, something went wrong while processing your payout. Please try again later or contact support."
        : "Your funds will be transferred to your bank account shortly.";
    },
  },
};
</script>

<style scoped>
.page-inside .hero-section .wrapper > .title {
  margin-bottom: 20px;
  text-align: center;
}

.desc {
  margin-bottom: 20px;
  text-align: center;
}

.actions {
  display: flex;
  justify-content: center;
}
</style>